module.exports = __webpack_public_path__ + "static/media/LosCabos.bffc3383.jpg";